<template>
  <div class="re-exhibit-container confirm">
    <div class="re-exhibit-wrap exhibit-confirm">
      <slot name="title"></slot>
      <div class="r-main">
        <form @submit.prevent>
          <BoxName :title_box="'物件種目'">
            <div class="input_block">
              <div class="label-wrap">
                <label>物件種目</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <CustomSelect :default="step1?.code_name ?? ''" class="select" :isReadonly="true"/>
                <div v-if="isConfirm" class="is_confirm">
                  <button type="button" @click="backToCategory">変更する</button>
                  <span class="r-input_validate"
                  >※「物件種目」を変更すると、「詳細情報」において入力済の一部内容がリセットされる場合があります</span
                  >
                </div>
              </div>
            </div>
          </BoxName>
          <BoxName :title_box="'地域・市区町村'">
            <div class="input_block">
              <div class="label-wrap">
                <label>郵便番号</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input permit-img">
                <div class="group_permit-img">
                  <input readonly type="text" required :value="step2.post_code"/>
                  <button type="button" class="btn_select btn_disable">住所検索</button>
                </div>
                <span class="validate-error" v-if="serverErrors?.post_code">
                  {{ serverErrors?.post_code }}
                </span>
              </div>
            </div>
            <div class="input_block">
              <div class="label-wrap">
                <label>都道府県</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <CustomSelect :default="step2.prefecture" class="select" :isReadonly="true"/>
                <span class="validate-error" v-if="serverErrors?.prefecture">
                  {{ serverErrors?.prefecture }}
                </span>
              </div>
            </div>
            <div class="input_block">
              <div class="label-wrap">
                <label>市区町村</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <input readonly type="text" required :value="step2.city"/>
                <span class="validate-error" v-if="serverErrors?.city">
                  {{ serverErrors?.city }}
                </span>
              </div>
            </div>
            <div class="input_block">
              <div class="label-wrap">
                <label>所在地情報1</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <input readonly type="text" required class="pr-130" :value="step2.address1"/>
                <div class="checkbox__wrap">
                  <input
                    disabled
                    id="login"
                    name="login"
                    type="checkbox"
                    :checked="!step2.address1_show_flag"
                    class="c-checkbox checkbox-confirm"
                  />
                  <label for="login">表示しない</label>
                </div>
                <span class="validate-error" v-if="serverErrors?.address1">
                  {{ serverErrors?.address1 }}
                </span>
              </div>
            </div>
            <div class="input_block">
              <div class="label-wrap">
                <label>所在地情報2</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <input readonly class="pr-130" type="text" required :value="step2.address2"/>
                <div class="checkbox__wrap">
                  <input
                    disabled
                    id="login"
                    :checked="!step2.address2_show_flag"
                    name="login"
                    type="checkbox"
                    class="c-checkbox checkbox-confirm"
                  />
                  <label for="login">表示しない</label>
                  <span class="validate-error" v-if="serverErrors?.address2">
                  {{ serverErrors?.address2 }}
                </span>
                </div>
              </div>
            </div>
            <div class="input_block">
              <div class="label-wrap">
                <label>所在地情報3</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <input readonly class="pr-130" type="text" required :value="step2.address3"/>
                <div class="checkbox__wrap">
                  <input
                    disabled
                    id="login"
                    :checked="!step2.address3_show_flag"
                    name="login"
                    type="checkbox"
                    class="c-checkbox checkbox-confirm"
                  />
                  <label for="login">表示しない</label>
                </div>
                <span class="validate-error" v-if="serverErrors?.address3">
                  {{ serverErrors?.address3 }}
                </span>
              </div>
            </div>
            <div class="input_block">
              <div class="label-wrap">
                <label>鉄道会社</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <CustomSelect :isReadonly="true" :default="step2.railroad_company" class="select"/>
                <span class="validate-error" v-if="serverErrors?.railroad_company">
                  {{ serverErrors?.railroad_company }}
                </span>
              </div>
            </div>
            <div class="input_block">
              <div class="label-wrap">
                <label>沿線名1</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <CustomSelect :isReadonly="true" class="select" :default="step2.train_line1"/>
                <span class="validate-error" v-if="serverErrors?.train_line1">
                  {{ serverErrors?.train_line1 }}
                </span>
              </div>
            </div>
            <div class="input_block">
              <div class="label-wrap">
                <label>駅名1</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <CustomSelect :isReadonly="true" :default="step2.station1" class="select"/>
                <span class="validate-error" v-if="serverErrors?.station1">
                  {{ serverErrors?.station1 }}
                </span>
              </div>
            </div>
            <div class="input_block">
              <div class="label-wrap">
                <label>沿線名2</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <CustomSelect :isReadonly="true" class="select" :default="step2.train_line2"/>
                <span class="validate-error" v-if="serverErrors?.train_line2">
                  {{ serverErrors?.train_line2 }}
                </span>
              </div>
            </div>
            <div class="input_block">
              <div class="label-wrap">
                <label>駅名2</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <CustomSelect :isReadonly="true" class="select" :default="step2.station2"/>
                <span class="validate-error" v-if="serverErrors?.station2">
                  {{ serverErrors?.station2 }}
                </span>
              </div>
            </div>
            <div class="input_block">
              <div class="label-wrap">
                <label>沿線名3</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <CustomSelect :isReadonly="true" class="select" :default="step2.train_line3"/>
                <span class="validate-error" v-if="serverErrors?.train_line3">
                  {{ serverErrors?.train_line3 }}
                </span>
              </div>
            </div>
            <div class="input_block">
              <div class="label-wrap">
                <label>駅名3</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <CustomSelect :isReadonly="true" class="select" :default="step2.station3"/>
                <span class="validate-error" v-if="serverErrors?.station3">
                  {{ serverErrors?.station3 }}
                </span>
              </div>
            </div>
            <div class="input_block">
              <div class="label-wrap">
                <label>最寄駅からの移動手段1</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <CustomSelect
                  :isReadonly="true"
                  :default="step2.transport_method1"
                  class="select"
                />
                <span class="validate-error" v-if="serverErrors?.transport_method1">
                  {{ serverErrors?.transport_method1 }}
                </span>
              </div>
            </div>
            <div class="input_block">
              <div class="label-wrap">
                <label>最寄駅からの所要時間(分以内)1</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <input readonly type="text" required :value="step2.transport_time1"/>
                <span class="validate-error" v-if="serverErrors?.transport_time1">
                  {{ serverErrors?.transport_time1 }}
                </span>
              </div>
            </div>
            <div class="input_block">
              <div class="label-wrap">
                <label>最寄駅からの移動手段2</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <CustomSelect
                  :isReadonly="true"
                  class="select"
                  :default="step2.transport_method2"
                />
                <span class="validate-error" v-if="serverErrors?.transport_method2">
                  {{ serverErrors?.transport_method2 }}
                </span>
              </div>
            </div>
            <div class="input_block">
              <div class="label-wrap">
                <label>最寄駅からの所要時間(分以内)2</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <input readonly type="text" required :value="step2.transport_time2"/>
                <span class="validate-error" v-if="serverErrors?.transport_time2">
                  {{ serverErrors?.transport_time2 }}
                </span>
              </div>
            </div>
            <div class="input_block">
              <div class="label-wrap">
                <label>最寄駅からの移動手段3</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <CustomSelect
                  :isReadonly="true"
                  class="select"
                  :default="step2.transport_method3"
                />
                <span class="validate-error" v-if="serverErrors?.transport_method3">
                  {{ serverErrors?.transport_method3 }}
                </span>
              </div>
            </div>
            <div class="input_block">
              <div class="label-wrap">
                <label>最寄駅からの所要時間(分以内)3</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <input readonly type="text" required :value="step2.transport_time3"/>
                <span class="validate-error" v-if="serverErrors?.transport_time3">
                  {{ serverErrors?.transport_time3 }}
                </span>
                <div v-if="isConfirm" class="is_confirm">
                  <button type="button" @click="backToAddress">変更する</button>
                </div>
              </div>
            </div>
          </BoxName>
          <BoxName :title_box="'詳細情報'">
            <div class="input_block i-b-vertical">
              <div class="label-wrap">
                <label>物件名</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <input readonly type="text" required :value="step3.estate_name"/>
                <span class="validate-error" v-if="serverErrors?.estate_name">
                  {{ serverErrors?.estate_name }}
                </span>
              </div>
            </div>
            <div class="input_block i-b-vertical" :class=" !isMobile && 'flex-3' ">
              <div class="label-wrap">
                <label>オークション形式</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <CustomSelect :isReadonly="true" :default="step3.bidding_type" class="select"/>
                <span class="validate-error" v-if="serverErrors?.bidding_type">
                  {{ serverErrors?.bidding_type }}
                </span>
              </div>
            </div>
            <div class="input_block i-b-vertical" :class=" !isMobile && 'flex-3' ">
              <div class="label-wrap">
                <label>開始価格</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <input readonly class="pr-sub" type="text"
                       :value="step3.price_init"/>
                <span class="r-input_eye-icon"> 万円 </span>
                <span class="validate-error" v-if="serverErrors?.price_init">
                  {{ serverErrors?.price_init }}
                </span>
              </div>
            </div>
            <div class="input_block i-b-vertical" :class=" !isMobile && 'flex-3' ">
              <div class="label-wrap">
                <label>即決価格</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <input readonly class="pr-sub" type="text"
                       :value="step3.price_min_bidding"/>
                <span class="r-input_eye-icon"> 万円 </span>
                <span class="validate-error" v-if="serverErrors?.price_min_bidding">
                  {{ serverErrors?.price_min_bidding }}
                </span>
              </div>
            </div>

            <div></div>

            <div class="input_block i-b-vertical" :class=" !isMobile && 'flex-3' ">
              <div class="label-wrap">
                <label>終了日</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <input readonly type="text" required :value="step3.end_date"/>
                <span class="validate-error" v-if="serverErrors?.end_date">
                  {{ serverErrors?.end_date }}
                </span>
              </div>
            </div>
            <div class="input_block i-b-vertical" :class=" !isMobile && 'flex-3' ">
              <div class="label-wrap">
                <label>目的</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <CustomSelect :isReadonly="true" :default="step3.purpose" class="select"/>
                <span class="validate-error" v-if="serverErrors?.purpose">
                  {{ serverErrors?.purpose }}
                </span>
              </div>
            </div>
            <div class="input_block i-b-vertical" :class=" !isMobile && 'flex-3' ">
              <div class="label-wrap">
                <label>取引態様</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <CustomSelect :isReadonly="true" :default="step3.transaction_mode" class="select"/>
                <span class="validate-error" v-if="serverErrors?.transaction_mode">
                  {{ serverErrors?.transaction_mode }}
                </span>
              </div>
            </div>
            <div></div>
            <div class="input_block i-b-vertical" :class=" !isMobile && 'flex-3' ">
              <div class="label-wrap">
                <label>報酬形態</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <CustomSelect
                  :isReadonly="true"
                  :default="step3.remuneration_type"
                  class="select"
                />
                <span class="validate-error" v-if="serverErrors?.remuneration_type">
                  {{ serverErrors?.remuneration_type }}
                </span>
              </div>
            </div>
            <div class="input_block i-b-vertical flex-3 flex-0"></div>
            <div class="input_block i-b-vertical flex-3 flex-0"></div>

            <hr/>
            <div></div>
            <div class="input_block i-b-vertical" :class=" !isMobile && 'flex-3' ">
              <div class="label-wrap">
                <label>構造</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <CustomSelect :isReadonly="true" :default="step3.structure" class="select"/>
                <span class="validate-error" v-if="serverErrors?.structure">
                  {{ serverErrors?.structure }}
                </span>
              </div>
            </div>
            <div class="input_block i-b-vertical" :class=" !isMobile && 'flex-3' ">
              <div class="label-wrap">
                <label>間取り</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <CustomSelect :isReadonly="true" :default="step3.building_map" class="select"/>
                <span class="validate-error" v-if="serverErrors?.building_map">
                  {{ serverErrors?.building_map }}
                </span>
              </div>
            </div>
            <div class="input_block i-b-vertical" :class=" !isMobile && 'flex-3' ">
              <div class="label-wrap">
                <label>総戸数</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <input readonly type="text" required :value="step3.total_flat"/>
                <span class="validate-error" v-if="serverErrors?.total_flat">
                  {{ serverErrors?.total_flat }}
                </span>
              </div>
            </div>

            <div></div>

            <div class="input_block i-b-vertical" :class=" !isMobile && 'flex-3' ">
              <div class="label-wrap">
                <label>地上階層</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <input readonly type="text" required
                       :value="totalFloorGround"/>
                <span class="validate-error" v-if="serverErrors?.total_floor_ground">
                  {{ serverErrors?.total_floor_ground }}
                </span>
              </div>
            </div>
            <div class="input_block i-b-vertical" :class=" !isMobile && 'flex-3' ">
              <div class="label-wrap">
                <label>地下階層</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <input readonly type="text" required
                       :value="totalFloorUnderground"/>
                <span class="validate-error" v-if="serverErrors?.total_floor_underground">
                  {{ serverErrors?.total_floor_underground }}
                </span>
              </div>
            </div>
            <div class="input_block i-b-vertical" :class=" !isMobile && 'flex-3' ">
              <div class="label-wrap">
                <label>所在階</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <input readonly type="text" required
                       :value="floorPosition"/>
                <span class="validate-error" v-if="serverErrors?.floor_position">
                  {{ serverErrors?.floor_position }}
                </span>
              </div>
            </div>

            <div></div>

            <div class="input_block i-b-vertical" :class=" !isMobile && 'flex-3' ">
              <div class="label-wrap">
                <label>土地の公簿面積</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <input readonly class="pr-sub" type="text" required
                       :value="step3.public_area"/>
                <span class="r-input_eye-icon"> m<sup>2</sup> </span>
                <span class="validate-error" v-if="serverErrors?.public_area">
                  {{ serverErrors?.public_area }}
                </span>
              </div>
            </div>
            <div class="input_block i-b-vertical" :class=" !isMobile && 'flex-3' ">
              <div class="label-wrap">
                <label>建物/専有の面積種別</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <CustomSelect :isReadonly="true" :default="step3.area_type" class="select"/>
                <span class="validate-error" v-if="serverErrors?.area_type">
                  {{ serverErrors?.area_type }}
                </span>
              </div>
            </div>
            <div class="input_block i-b-vertical" :class=" !isMobile && 'flex-3' ">
              <div class="label-wrap">
                <label>建物/専有の面積</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <input readonly class="pr-sub" type="text" required
                       :value="step3.own_area"/>
                <span class="r-input_eye-icon"> m<sup>2</sup> </span>
                <span class="validate-error" v-if="serverErrors?.own_area">
                  {{ serverErrors?.own_area }}
                </span>
              </div>
            </div>

            <div></div>

            <div class="input_block i-b-vertical" :class=" !isMobile && 'flex-3' ">
              <div class="label-wrap">
                <label>土地権利</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <CustomSelect :isReadonly="true" :default="step3.land_ownership" class="select"/>
                <span class="validate-error" v-if="serverErrors?.land_ownership">
                  {{ serverErrors?.land_ownership }}
                </span>
              </div>
            </div>
            <div class="input_block i-b-vertical" :class=" !isMobile && 'flex-3' ">
              <div class="label-wrap">
                <label>管理会社</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <input readonly type="text" required :value="step3.management_company"/>
                <span class="validate-error" v-if="serverErrors?.management_company">
                  {{ serverErrors?.management_company }}
                </span>
              </div>
            </div>
            <div class="input_block i-b-vertical" :class=" !isMobile && 'flex-3' ">
              <div class="label-wrap">
                <label>管理形態</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <CustomSelect
                  :isReadonly="true"
                  :default="step3.management_method"
                  class="select"
                />
                <span class="validate-error" v-if="serverErrors?.management_method">
                  {{ serverErrors?.management_method }}
                </span>
              </div>
            </div>

            <div></div>

            <div class="input_block i-b-vertical" :class=" !isMobile && 'flex-3' ">
              <div class="label-wrap">
                <label>管理費</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <input readonly class="pr-sub" type="text"
                       :value="step3.management_fee ? step3.management_fee : '' "/>
                <span class="r-input_eye-icon"> 円 </span>
                <span class="validate-error" v-if="serverErrors?.management_fee">
                  {{ serverErrors?.management_fee }}
                </span>
              </div>
            </div>
            <div class="input_block i-b-vertical" :class=" !isMobile && 'flex-3' ">
              <div class="label-wrap">
                <label>築年月（西暦+月）</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <input readonly type="text" required :value="step3.construct_date"/>
                <span class="validate-error" v-if="serverErrors?.construct_date">
                  {{ serverErrors?.construct_date }}
                </span>
              </div>
            </div>
            <div class="input_block i-b-vertical" :class=" !isMobile && 'flex-3' ">
              <div class="label-wrap">
                <label>修繕積立金</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <input readonly class="pr-sub" type="text"
                       :value="step3.repairment_fund"/>
                <span class="r-input_eye-icon"> 円 </span>
                <span class="validate-error" v-if="serverErrors?.repairment_fund">
                  {{ serverErrors?.repairment_fund }}
                </span>
              </div>
            </div>

            <div></div>

            <div class="input_block i-b-vertical" :class=" !isMobile && 'flex-3' ">
              <div class="label-wrap">
                <label>管理費/修繕積立金の改訂予定</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <input readonly type="text" required :value="step3.repair_fund_schedule"/>
                <span class="validate-error" v-if="serverErrors?.repair_fund_schedule">
                  {{ serverErrors?.repair_fund_schedule }}
                </span>
              </div>
            </div>
            <div class="input_block i-b-vertical" :class=" !isMobile && 'flex-3' ">
              <div class="label-wrap">
                <label>賃貸管理形態</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <CustomSelect
                  :isReadonly="true"
                  :default="step3.rental_management_method"
                  class="select"
                />
                <span class="validate-error" v-if="serverErrors?.rental_management_method">
                  {{ serverErrors?.rental_management_method }}
                </span>
              </div>
            </div>
            <div class="input_block i-b-vertical" :class=" !isMobile && 'flex-3' ">
              <div class="label-wrap">
                <label>賃貸管理の解除条件</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <input readonly type="text" :value="step3.cancel_condition"/>
                <span class="validate-error" v-if="serverErrors?.cancel_condition">
                  {{ serverErrors?.cancel_condition }}
                </span>
              </div>
            </div>

            <div></div>

            <div class="input_block i-b-vertical" :class=" !isMobile && 'flex-3' ">
              <div class="label-wrap">
                <label>現状</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <CustomSelect :isReadonly="true" :default="step3.situation" class="select"/>
                <span class="validate-error" v-if="serverErrors?.situation">
                  {{ serverErrors?.situation }}
                </span>
              </div>
            </div>
            <div class="input_block i-b-vertical" :class=" !isMobile && 'flex-3' ">
              <div class="label-wrap">
                <label>最短の引渡日</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <input readonly type="text" required :value="step3.shortest_delivery_date"/>
                <span class="validate-error" v-if="serverErrors?.shortest_delivery_date">
                  {{ serverErrors?.shortest_delivery_date }}
                </span>
              </div>
            </div>
            <div class="input_block i-b-vertical" :class=" !isMobile && 'flex-3' ">
              <div class="label-wrap">
                <label>手付金</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <input readonly class="pr-sub" type="text"
                       :value="step3.deposit"/>
                <span class="r-input_eye-icon"> 万円 </span>
                <span class="validate-error" v-if="serverErrors?.deposit">
                  {{ serverErrors?.deposit }}
                </span>
              </div>
            </div>

            <div></div>

            <div class="input_block i-b-vertical" :class=" !isMobile && 'flex-3' ">
              <div class="label-wrap">
                <label>入居賃料</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <input readonly class="pr-sub" type="text"
                       :value="step3.move_in_fee"/>
                <span class="r-input_eye-icon"> 円 </span>
                <span class="validate-error" v-if="serverErrors?.move_in_fee">
                  {{ serverErrors?.move_in_fee }}
                </span>
              </div>
            </div>
            <div class="input_block i-b-vertical flex-3 flex-0"></div>
            <div class="input_block i-b-vertical flex-3 flex-0"></div>

            <hr/>

            <div class="input_block i-b-vertical">
              <div class="label-wrap">
                <label>画像</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <ImgUpload :isPostImg="false" :images="step3.images"/>
              </div>
            </div>
            <div class="input_block i-b-vertical css-pdf" :class="!isMobile && 'flex-3 mr-10'">
              <div class="label-wrap">
                <label>謄本</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <div
                  class="progress-wrap"
                  v-for="(item, key) in documentsByType(DOCUMENT_TYPES.TRANSCRIPT)"
                  :key="key"
                >
                  <div class="p-icon">
                    <img
                      src="@/assets/images/document-pdf-gray.svg"
                      alt="doc"
                      width="26"
                      height="26"
                    />
                  </div>
                  <div class="p-main">
                    <div class="p-sub">
                      <div class="p-name posted">
                        {{ item.name }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="input_block i-b-vertical">
              <AppCheckBox
                :checked="!step3.transcipt_show_flag"
                title="表示しない"
                :disabled="true"
              />
            </div>
            <div class="input_block i-b-vertical" :class=" !isMobile && 'flex-3' ">
              <div class="label-wrap">
                <label>重要事項調査報告書</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <div
                  class="progress-wrap"
                  v-for="(item, key) in documentsByType(
                    DOCUMENT_TYPES.IMPORTANT_INVESTIGATION_REPORT
                  )"
                  :key="key"
                >
                  <div class="p-icon">
                    <img
                      src="@/assets/images/document-pdf-gray.svg"
                      alt="doc"
                      width="26"
                      height="26"
                    />
                  </div>
                  <div class="p-main">
                    <div class="p-sub">
                      <div class="p-name posted">
                        {{ item.name }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <hr/>

            <div class="input_block i-b-vertical">
              <div class="label-wrap">
                <label>備考</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <TextArea
                  v-for="(note, i) in step3.note"
                  :key="i"
                  :content="note.note"
                  :isPostTextarea="true"
                  :hasEditable="false"
                />
                <div></div>
              </div>
            </div>

            <hr/>

            <div class="input_block i-b-vertical" :class=" !isMobile && 'flex-3' ">
              <div class="label-wrap">
                <label>建築面積</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <input readonly class="pr-sub" type="text"
                       :value="step3.construct_area"/>
                <span class="r-input_eye-icon"> m<sup>2</sup> </span>
                <span class="validate-error" v-if="serverErrors?.construct_area">
                  {{ serverErrors?.construct_area }}
                </span>
              </div>
            </div>
            <div class="input_block i-b-vertical" :class=" !isMobile && 'flex-3' ">
              <div class="label-wrap">
                <label>延床面積</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <input readonly class="pr-sub" type="text"
                       :value="step3.total_floor_area"/>
                <span class="r-input_eye-icon"> m<sup>2</sup> </span>
                <span class="validate-error" v-if="serverErrors?.total_floor_area">
                  {{ serverErrors?.total_floor_area }}
                </span>
              </div>
            </div>
            <div class="input_block i-b-vertical" :class=" !isMobile && 'flex-3' ">
              <div class="label-wrap">
                <label>道路幅員</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <input readonly class="pr-sub" type="text"
                       :value="step3.road_width"/>
                <span class="r-input_eye-icon"> m </span>
                <span class="validate-error" v-if="serverErrors?.road_width">
                  {{ serverErrors?.road_width }}
                </span>
              </div>
            </div>

            <div></div>

            <div class="input_block i-b-vertical" :class=" !isMobile && 'flex-3' ">
              <div class="label-wrap">
                <label>地目</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <CustomSelect :isReadonly="true" :default="step3.type_of_land" class="select"/>
                <span class="validate-error" v-if="serverErrors?.type_of_land">
                  {{ serverErrors?.type_of_land }}
                </span>
              </div>
            </div>
            <div class="input_block i-b-vertical" :class=" !isMobile && 'flex-3' ">
              <div class="label-wrap">
                <label>用途地域</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <CustomSelect :isReadonly="true" :default="step3.use_of_area" class="select"/>
                <span class="validate-error" v-if="serverErrors?.use_of_area">
                  {{ serverErrors?.use_of_area }}
                </span>
              </div>
            </div>

            <div class="input_block i-b-vertical" :class=" !isMobile && 'flex-3' ">
              <div class="label-wrap">
                <label>地域・地区</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <CustomSelect :isReadonly="true" :default="step3.district" class="select"/>
                <span class="validate-error" v-if="serverErrors?.district">
                  {{ serverErrors?.district }}
                </span>
              </div>
            </div>

            <div></div>

            <div class="input_block i-b-vertical" :class=" !isMobile && 'flex-3' ">
              <div class="label-wrap">
                <label>建蔽率</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <input readonly class="pr-sub" type="text"
                       :value="step3.construction_coverage"/>
                <span class="r-input_eye-icon"> % </span>
                <span class="validate-error" v-if="serverErrors?.construction_coverage">
                  {{ serverErrors?.construction_coverage }}
                </span>
              </div>
            </div>
            <div class="input_block i-b-vertical" :class=" !isMobile && 'flex-3' ">
              <div class="label-wrap">
                <label>容積率</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <input readonly class="pr-sub" type="text"
                       :value="step3.using_area_ratio"/>
                <span class="r-input_eye-icon"> % </span>
                <span class="validate-error" v-if="serverErrors?.using_area_ratio">
                  {{ serverErrors?.using_area_ratio }}
                </span>
              </div>
            </div>
            <div class="input_block i-b-vertical" :class=" !isMobile && 'flex-3' ">
              <div class="label-wrap">
                <label>駐車場</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <CustomSelect :isReadonly="true" :default="step3.parking_car" class="select"/>
                <span class="validate-error" v-if="serverErrors?.parking_car">
                  {{ serverErrors?.parking_car }}
                </span>
              </div>
            </div>

            <div></div>

            <div class="input_block i-b-vertical" :class=" !isMobile && 'flex-3' ">
              <div class="label-wrap">
                <label>バイク置き場</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <CustomSelect :isReadonly="true" :default="step3.parking_motobike" class="select"/>
                <span class="validate-error" v-if="serverErrors?.parking_motorbike">
                  {{ serverErrors?.parking_motorbike }}
                </span>
              </div>
            </div>
            <div class="input_block i-b-vertical" :class=" !isMobile && 'flex-3' ">
              <div class="label-wrap">
                <label>駐輪場</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <CustomSelect :isReadonly="true" :default="step3.parking_bike" class="select"/>
                <span class="validate-error" v-if="serverErrors?.parking_bike">
                  {{ serverErrors?.parking_bike }}
                </span>
              </div>
            </div>
            <div class="input_block i-b-vertical" :class=" !isMobile && 'flex-3' ">
              <div class="label-wrap">
                <label> ガス</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <input readonly type="text" required :value="step3.gas_service"/>
                <span class="validate-error" v-if="serverErrors?.gas_service">
                  {{ serverErrors?.gas_service }}
                </span>
              </div>
            </div>

            <div></div>

            <div class="input_block i-b-vertical" :class=" !isMobile && 'flex-3' ">
              <div class="label-wrap">
                <label> 水道</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <input readonly type="text" required :value="step3.water_service"/>
                <span class="validate-error" v-if="serverErrors?.water_service">
                  {{ serverErrors?.water_service }}
                </span>
              </div>
            </div>
            <div class="input_block i-b-vertical" :class=" !isMobile && 'flex-3' ">
              <div class="label-wrap">
                <label> 電気</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <input readonly type="text" required :value="step3.eletric_service"/>
                <span class="validate-error" v-if="serverErrors?.electric_service">
                  {{ serverErrors?.electric_service }}
                </span>
              </div>
            </div>
            <div class="input_block i-b-vertical" :class=" !isMobile && 'flex-3' ">
              <div class="label-wrap">
                <label> 排水</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <input readonly type="text" required :value="step3.waste_water_service"/>
                <span class="validate-error" v-if="serverErrors?.waste_water_service">
                  {{ serverErrors?.waste_water_service }}
                </span>
              </div>
            </div>

            <div></div>

            <div class="input_block i-b-vertical" :class=" !isMobile && 'flex-3' ">
              <div class="label-wrap">
                <label> 分譲主</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <input readonly type="text" required :value="step3.distribution_seller"/>
                <span class="validate-error" v-if="serverErrors?.distribution_seller">
                  {{ serverErrors?.distribution_seller }}
                </span>
              </div>
            </div>
            <div class="input_block i-b-vertical" :class=" !isMobile && 'flex-3' ">
              <div class="label-wrap">
                <label>施工会社</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <input readonly type="text" required :value="step3.construction_company"/>
                <span class="validate-error" v-if="serverErrors?.construction_company">
                  {{ serverErrors?.construction_company }}
                </span>
              </div>
            </div>
            <div class="input_block i-b-vertical" :class=" !isMobile && 'flex-3' ">
              <div class="label-wrap">
                <label>設計・整理会社</label>
              </div>
              <div class="required-wrap"></div>
              <div class="r-input">
                <input readonly type="text" required :value="step3.design_company"/>
                <span class="validate-error" v-if="serverErrors?.design_company">
                  {{ serverErrors?.design_company }}
                </span>
              </div>
            </div>
            <div class="input_block i-b-vertical flex-3 flex-0"></div>
            <div class="input_block i-b-vertical flex-3 flex-0"></div>

            <hr/>
            <div class="input_block i-b-vertical">
              <div class="r-input">
                <div v-if="isConfirm" class="is_confirm mt-0 alg_center">
                  <button type="button" @click="backToDetailInfo">変更する</button>
                </div>
              </div>
            </div>
          </BoxName>

          <div class="btn-wrap">
            <div class="btn-wrap-two">
              <slot name="btn"></slot>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CustomSelect from '@/components/Selects/CusSelect.vue';
import ImgUpload from '@/components/Upload/UploadImgs.vue';
// import PdfUpload from '@/components/Upload/UploadPdfs.vue';
import TextArea from '@/components/Textarea/index.vue';
import BoxName from '@/views/EstateDetailSeller/components/box-name.vue';
import { DOCUMENT_TYPES } from '@/constants/estate';
import {
  NUMBER_EN_US_FORMAT,
} from '@/constants/common';

export default {
  components: {
    CustomSelect,
    ImgUpload,
    // PdfUpload,
    TextArea,
    BoxName,
  },
  props: {
    isConfirm: {
      type: Boolean,
      default: false,
    },
    dataConfirm: {
      type: Array,
    },
    serverErrors: {
      type: Object,
      default: () => {
      },
    },
  },
  data() {
    return {
      NUMBER_EN_US_FORMAT,
      DOCUMENT_TYPES,
    };
  },
  computed: {
    ...mapGetters('common', ['isMobile']),
    step1() {
      return this.dataConfirm.find((obj) => obj.step === 1).value;
    },
    step2() {
      return this.dataConfirm.find((obj) => obj.step === 2).value;
    },
    step3() {
      return this.dataConfirm.find((obj) => obj.step === 3).value;
    },
    totalFloorGround() {
      return (this.step3.total_floor_ground || this.step3.total_floor_ground === 0)
        ? this.step3.total_floor_ground
        : '';
    },
    totalFloorUnderground() {
      return (this.step3.total_floor_underground || this.step3.total_floor_underground === 0)
        ? this.step3.total_floor_underground
        : '';
    },
    floorPosition() {
      return (this.step3.floor_position || this.step3.floor_position === 0)
        ? this.step3.floor_position
        : '';
    },
  },
  // created() {
  //   this.getCategoryMaster();
  // },
  methods: {
    // getCategoryMaster() {
    //   this.$store.dispatch('common/getCategoryMaster');
    // },
    backToCategory() {
      this.$store.commit('modal/changeContinueActionStatus', true);
      this.$router.push({ name: 'EstateCategory' });
    },
    backToAddress() {
      this.$store.commit('modal/changeContinueActionStatus', true);
      this.$router.push({ name: 'EstateAddress' });
    },
    backToDetailInfo() {
      this.$store.commit('modal/changeContinueActionStatus', true);
      this.$router.push({ name: 'EstateDetailInfo' });
    },

    documentsByType(type) {
      return this.$filterByProperty(this.step3?.document_link, 'type', type);
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/reExhibit/index.scss';
</style>
